<template>
  <div
    class="
      flex
      justify-between
      items-center
      shadow
      border-gray-200
      bg-gray-50
      border
      overflow-hidden
      sm:rounded-lg
      px-4
      py-5
      sm:p-6
      sm:pl-4
      mb-14
    "
  >
    <div class="flex">
      <div class="relative mt-0.5">
        <UserIcon class="w-8 h-7 text-vice-teal-500 mr-4" />
        <CheckIcon class="w-5 h-6 text-vice-teal-500 absolute left-5 top-0" />
      </div>
      <div>
        <h2 class="text-lg font-medium text-vice-dark-teal leading-10">Participation accepted</h2>
        <span class="inline-grid mt-1 py-0.5 px-2.5 text-center rounded-full bg-vice-teal-600">
          <span class="text-xxs text-white font-medium">Prepare for session</span>
        </span>
      </div>
    </div>
    <button
      @click="this.$emit('prepareSessionClicked')"
      class="
        ml-3
        inline-flex
        items-center
        px-6
        border border-transparent
        rounded-md
        shadow-sm
        text-sm
        font-medium
        text-white
        bg-vice-teal-500
        hover:bg-vice-teal-600
        focus:outline-none
        focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
        h-11
        self-center
      "
    >
      <PencilAltIcon class="h-5 w-5 mr-1"></PencilAltIcon>
      Your learning goals
    </button>
  </div>
</template>

<script>
import { PencilAltIcon, UserIcon, CheckIcon } from '@heroicons/vue/outline';

export default {
  name: 'ParticipantLearningGoals',
  components: {
    PencilAltIcon,
    UserIcon,
    CheckIcon,
  },
};
</script>

<style scoped></style>
